/**
 * Sales / customer-service contact points. The WhatsApp number is the same
 * one jarvis-website publishes (src/lib/site.ts, CONTACT.whatsappNumber); keep
 * the two in step when it changes.
 */
export const SALES_WHATSAPP_NUMBER = '6282153960896';
export const SALES_WHATSAPP_DISPLAY = '+62 821-5396-0896';

/** wa.me deep link to sales, with an optional prefilled message. */
export function salesWhatsappLink(message?: string): string {
  const base = `https://wa.me/${SALES_WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
